<template>
  <Modal
    class="delivery-dlg"
    v-model="show"
    title="填写发货单"
    @on-visible-change="onVisibleChange"
  >
    <Form ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="订单编号">{{ data.order_number }}</FormItem>
      <FormItem label="物流公司" prop="logistics_name">
        <Input
          v-model="form.logistics_name"
          type="text"
          placeholder="请输入物流公司名称"
          :maxlength="50"
        ></Input>
      </FormItem>
      <FormItem label="物流单号" prop="logistics_code">
        <Input
          v-model="form.logistics_code"
          type="text"
          placeholder="请输入物流单号"
          :maxlength="50"
        ></Input>
      </FormItem>
      <FormItem label="发货说明" prop="remark">
        <Input
          v-model="form.remark"
          type="textarea"
          placeholder="请输入发货说明"
          :rows="3"
          :maxlength="500"
        ></Input>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align:center;">
      <Button type="primary" @click="onOk" size="large" style="width:100px;"
        >确定</Button
      >
    </div>
  </Modal>
</template>

<script>
export default {
  name: "delivery-dlg",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      show: false,
      form: {
        logistics_name: "",
        logistics_code: "",
        remark: ""
      },
      rules: {
        logistics_name: [
          { required: true, message: "请输入物流公司", trigger: "blur" }
        ],
        logistics_code: [
          { required: true, message: "请输入物流单号", trigger: "blur" }
        ],
        remark: [{ required: true, message: "请输入发货说明", trigger: "blur" }]
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.show = val;
      }
    },
    show(val) {
      this.$emit("input", val);
    }
  },
  created() {},
  methods: {
    // on event
    onOk() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const params = Object.assign(
          {
            order_id: this.data.order_id
          },
          this.form
        );
        this.$http.post("/api/ship/createDelivery", params).then(() => {
          this.show = false;
          this.$Message.success("发货成功");
          this.$emit("on-ok");
        });
      });
    },
    onVisibleChange(val) {
      if (val) {
        this.form.logistics_name = "";
        this.form.logistics_code = "";
        this.form.remark = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
